import { useDispatch, useSelector } from "react-redux";
import Card from "react-bootstrap/Card";
import React from "react";
import Skeleton from "react-loading-skeleton";
import { push } from "connected-react-router";
import styles from "../styles/NavigationPanel.module.scss";
import { useParams } from "react-router-dom";
import { v4 } from "uuid";

const NavigationPanel = () => {
  const { dir, subpage } = useParams();
  const { data, isLoading } = useSelector((state) => state.pagedata);
  const dispatch = useDispatch();

  const card = data?.container?.json_dict?.card;
  const partnercounts = data?.panels?.partnercounts;
  const tribelinks = data?.panels?.tribelinks;

  const changeTheme = (theme) =>
    dispatch(push(`/${dir}/${card.sanitized_wo}${theme}`, { noTop: true }));
  const isLoadingLongNav = isLoading && ["average-decks", "commanders", "decks"].includes(dir);
  const defaultBudgets = [
    { "href-suffix": "#", html: <Skeleton /> },
    { "href-suffix": "#", html: <Skeleton /> },
  ];

  return (
    <>
      <h5 className="title">Navigation</h5>
      <Card className="shadow-sm">
        <Card.Body>
          {(isLoadingLongNav || (tribelinks && tribelinks.themes.length > 1)) && (
            <div className={styles.theme}>
              <h5>{isLoadingLongNav ? <Skeleton /> : "By Theme"}</h5>
              {isLoadingLongNav ? (
                <h1>
                  <Skeleton />
                </h1>
              ) : (
                <select
                  className="form-control"
                  onChange={(e) => changeTheme(e.target.value)}
                  value={`/${subpage}`}
                >
                  <option></option>
                  {tribelinks?.themes.map((tribelink) => (
                    <option value={tribelink["href-suffix"]} key={tribelink["href-suffix"]}>
                      {tribelink.value} ({tribelink.count})
                    </option>
                  ))}
                </select>
              )}
            </div>
          )}
          {(isLoadingLongNav || (tribelinks && tribelinks.budget.length > 1)) && (
            <div className={styles.budget}>
              <h5>{isLoadingLongNav ? <Skeleton /> : "By Budget"}</h5>
              <div className="form-check">
                <input
                  checked={!["budget", "expensive"].includes(subpage)}
                  className="form-check-input"
                  id="all"
                  onChange={() => changeTheme("")}
                  type="radio"
                />
                {isLoadingLongNav ? (
                  <Skeleton />
                ) : (
                  <label className="form-check-label" htmlFor="all">
                    All
                  </label>
                )}
              </div>
              {(isLoadingLongNav ? defaultBudgets : tribelinks?.budget).map((item) => (
                <div className="form-check" key={v4()}>
                  <input
                    checked={subpage == item["href-suffix"].slice(1)}
                    className="form-check-input"
                    id={item["href-suffix"]}
                    onChange={(e) => changeTheme(e.target.id)}
                    type="radio"
                  />
                  {item?.html || (
                    <label className="form-check-label" htmlFor={item["href-suffix"]}>
                      {item.value}
                    </label>
                  )}
                </div>
              ))}
            </div>
          )}
          {partnercounts && (
            <div className={styles.theme}>
              <h5>Partners</h5>
              <select
                className="form-control"
                onChange={(e) => dispatch(push(e.target.value, { noTop: true }))}
              >
                <option></option>
                {partnercounts.map((item) => (
                  <option value={item.href} key={item.href}>
                    {item.value}
                  </option>
                ))}
              </select>
            </div>
          )}
          {/* combocounts && (
            <div className={styles.theme}>
              <h5>Combos</h5>
              <select
                className="form-control"
                onChange={(e) => dispatch(push(e.target.value, { noTop: true }))}
              >
                <option></option>
                {combocounts.map((item) => (
                  <option value={item.href} key={item.href}>
                    {item.value}
                  </option>
                ))}
              </select>
            </div>
                )*/}
          {((tribelinks && (tribelinks.themes || tribelinks.budget)) || isLoadingLongNav) && (
            <h5>Links</h5>
          )}
          <div className={styles.relatedLinks}>
            {isLoading && !card ? (
              <>
                <Skeleton />
                <Skeleton />
                <Skeleton />
                <Skeleton />
                <Skeleton />
                <Skeleton />
                <Skeleton />
                <Skeleton />
              </>
            ) : (
              [
                {
                  href: (str) =>
                    str.startsWith("https://")
                      ? str
                      : `https://aetherhub.com/Meta/Format/Commander/?com=${str}&updated=all-time`,
                  key: "aetherhub_uri",
                  value: "Aetherhub",
                },
                {
                  href: (str) =>
                    str.startsWith("https://")
                      ? str
                      : `https://archidekt.com/search/decks/commanders=${str}&formats=3`,
                  key: "archidekt_uri",
                  value: "Archidekt",
                },
                {
                  href: (str) =>
                    str.startsWith("https://")
                      ? str
                      : `https://deckstats.net/decks/search/?search_cards_commander[]=${str}&search_format=10`,
                  key: "deckstats_uri",
                  value: "Deckstats",
                },
                {
                  href: (str) =>
                    str.startsWith("https://")
                      ? str
                      : `https://gatherer.wizards.com/Pages/Card/Details.aspx?multiverseid=${str}`,
                  key: "gatherer_uri",
                  value: "Gatherer",
                },
                {
                  href: (str) =>
                    str.startsWith("https://") ? str : `https://moxfield.com/search?q=${str}`,
                  key: "moxfield_uri",
                  value: "Moxfield",
                },
                {
                  href: (str) =>
                    str.startsWith("https://")
                      ? str
                      : `https://www.mtggoldfish.com/deck/custom?mformat=commander&commander=${str}`,
                  key: "mtggoldfish_uri",
                  value: "MTGGoldfish",
                },
                {
                  href: (str) =>
                    str.startsWith("https://")
                      ? str
                      : `https://scryfall.com/card/${str}?utm_source=api`,
                  key: "scryfall_uri",
                  value: "Scryfall",
                },
              ]
                .filter(({ key }) => card[key])
                .map(({ href, key, value }) => (
                  <div key={key}>
                    <a href={href(card[key])} rel="noreferrer" target="_blank">
                      {value}
                    </a>
                  </div>
                ))
            )}
          </div>
        </Card.Body>
      </Card>
    </>
  );
};

export default NavigationPanel;
